import type { VariableConfig } from "../fields/types";
import type { DynamicValueOption } from "../types/Menu";
import { getDynamicValueIcon } from "../utils/menu/optionIconUtil";
import type VariableId from "./VariableId";
import VariableValueReference from "./VariableValueReference";
import type { VariableType } from "./types";

export const toVariableValueOption = (variable: VariableConfig): DynamicValueOption<VariableValueReference> => {
  const id = VariableValueReference.from(variable.uid.toString());
  const icon = getDynamicValueIcon(id, variable.type);

  return {
    variant: "dynamicValue",
    value: VariableValueReference.from(variable.uid.toString()),
    label: variable.name,
    pill: variable.dataName,
    icon,
  };
};

export const toVariableOption = (variable: VariableConfig): DynamicValueOption<VariableId> => {
  const icon = getDynamicValueIcon(variable.uid, variable.type);

  return {
    variant: "dynamicValue",
    value: variable.uid,
    label: variable.name,
    pill: variable.dataName,
    icon,
  };
};

export const SEARCHABLE_VARIABLES: VariableType[] = ["string", "number", "boolean", "date", "datetime"] as const;

export const SUMMARIZABLE_VARIABLES: VariableType[] = ["string", "number", "boolean", "date", "datetime"] as const;

export const RECIPIENT_ALLOWED_PLACEHOLDER_VARIABLES: VariableType[] = ["string"] as const;
